import { render, staticRenderFns } from "./LeftLowerBarProjects.vue?vue&type=template&id=c219d672&scoped=true&"
import script from "./LeftLowerBarProjects.vue?vue&type=script&lang=js&"
export * from "./LeftLowerBarProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c219d672",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c219d672')) {
      api.createRecord('c219d672', component.options)
    } else {
      api.reload('c219d672', component.options)
    }
    module.hot.accept("./LeftLowerBarProjects.vue?vue&type=template&id=c219d672&scoped=true&", function () {
      api.rerender('c219d672', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/LowerBar/LowerBarLeftSide/LeftLowerBarProjects.vue"
export default component.exports